import Select from "react-select";
import {
    ACP_COLOR_OPTIONS,
    CEILING_COLOR_OPTIONS,
    CEILING_MATERIAL_OPTIONS,
    REPLACEMENT_PANEL_OPTIONS,
    SIDE_HOARDING_OPTIONS,
} from "../../../constants/awningSupplementaryOptions";

const AwningSupplementaryFields = ({
    item,
    category,
    idx,
    updateAwningItem,
    awningSelectStyles,
    hideColors = false,
    onlyColors = false,
    showAcpColor = true,
    showCeilingColor = true,
    ceilingColorOptions = CEILING_COLOR_OPTIONS,
    acpColorOptions = ACP_COLOR_OPTIONS,
    ceilingMaterialOptions = CEILING_MATERIAL_OPTIONS,
}) => {
    const selectValue = (options, value) =>
        value
            ? options.find((option) => option.value === value) || {
                  label: value,
                  value,
              }
            : null;

    const handleSelectChange = (field) => (option) =>
        updateAwningItem(category, idx, field, option ? option.value : undefined);

    const handlePriceChange = (field) => (event) =>
        updateAwningItem(
            category,
            idx,
            field,
            event.target.value ? parseFloat(event.target.value) : "",
        );

    const ceilingColorField = (
        <div className="addProductItem">
            <label>Ceiling Color</label>
            <Select
                isClearable
                styles={awningSelectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                value={selectValue(ceilingColorOptions, item.ceilingColor)}
                onChange={handleSelectChange("ceilingColor")}
                options={ceilingColorOptions}
                placeholder="Select Ceiling Color"
            />
        </div>
    );

    const acpColorField = (
        <div className="addProductItem">
            <label>ACP Color</label>
            <Select
                isClearable
                styles={awningSelectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                value={selectValue(acpColorOptions, item.acpColor)}
                onChange={handleSelectChange("acpColor")}
                options={acpColorOptions}
                placeholder="Select ACP Color"
            />
        </div>
    );

    if (onlyColors) {
        return (
            <>
                {showAcpColor && acpColorField}
                {showCeilingColor && ceilingColorField}
            </>
        );
    }

    return (
        <>
            <div className="addProductItem">
                <label>Ceiling Material</label>
                <Select
                    isClearable
                    styles={awningSelectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    value={selectValue(ceilingMaterialOptions, item.ceilingMaterial)}
                    onChange={handleSelectChange("ceilingMaterial")}
                    options={ceilingMaterialOptions}
                    placeholder="Select Ceiling Material"
                />
            </div>
            {!hideColors && ceilingColorField}
            {!hideColors && acpColorField}
            <div className="addProductItem">
                <label>Ceiling Price</label>
                <input
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    value={item.ceilingPrice ?? ""}
                    onChange={handlePriceChange("ceilingPrice")}
                />
            </div>
            <div className="addProductItem">
                <label>Replacement Panel</label>
                <Select
                    isClearable
                    styles={awningSelectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    value={selectValue(
                        REPLACEMENT_PANEL_OPTIONS,
                        item.replacementPanel,
                    )}
                    onChange={handleSelectChange("replacementPanel")}
                    options={REPLACEMENT_PANEL_OPTIONS}
                    placeholder="Select Replacement Panel"
                />
            </div>
            <div className="addProductItem">
                <label>Replacement Panel Price</label>
                <input
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    value={item.replacementPanelPrice ?? ""}
                    onChange={handlePriceChange("replacementPanelPrice")}
                />
            </div>
            <div className="addProductItem">
                <label>Side Hoarding</label>
                <Select
                    isClearable
                    styles={awningSelectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    value={selectValue(SIDE_HOARDING_OPTIONS, item.sideHoarding)}
                    onChange={handleSelectChange("sideHoarding")}
                    options={SIDE_HOARDING_OPTIONS}
                    placeholder="Select Side Hoarding"
                />
            </div>
            <div className="addProductItem">
                <label>Side Hoarding Price</label>
                <input
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    value={item.sideHoardingPrice ?? ""}
                    onChange={handlePriceChange("sideHoardingPrice")}
                />
            </div>
        </>
    );
};

export default AwningSupplementaryFields;
